import { Injectable, EventEmitter } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class Api {
  createEvento(eventPayload: {
    diasRecurrencia: string[];
    title: string;
    description: string;
    status: string;
    assignedTo: string;
    fechaInicio: string;
    fechaFin: string;
    horaInicio: string;
    horaFin: string;
    priority: string;
    relatedTo: string;
    ubicacion: string;
    tipoEvento: string;
    enlaceVirtual: string;
    color: string;
    repeatEvent: boolean;
    frecuencia: string;
    finRecurrencia: string;
    fechaFinRecurrencia: string;
    numeroOcurrencias: number;
    reminderEnabled: boolean;
    tiempoRecordatorio: string;
    recordatorioCantidad: number;
    recordatorioUnidad: string;
    allDay: boolean;
  }) {
    throw new Error('Method not implemented.');
  }
  apiUrl: string = environment.api;

  constructor(private http: HttpClient) {}

  public fireLoading: EventEmitter<boolean> = new EventEmitter();

  showLoading() {
    this.fireLoading.emit(true);
  }

  hideLoading() {
    this.fireLoading.emit(false);
  }

  public get(url: string, body?: any) {
    let headers = new HttpHeaders();
    // headers = headers.append('Clear-Site-Data', 'cache');
    headers = headers.append('Authorization', this.getToken());
    //headers=headers.append('ngrok-skip-browser-warning', '69420');
    return this.http.get(environment.api + url, {
      params: body,
      headers: headers,
    });
  }

  public post(url: string, body?: any) {
    let headers = new HttpHeaders();
    // headers = headers.append('Clear-Site-Data', 'cache');
    headers = headers.append('Authorization', this.getToken());
    return this.http.post(environment.api + url, body, { headers: headers });
  }

  public put(url: string, body?: any) {
    return this.http.put(environment.api + url, body, {
      headers: new HttpHeaders().append('Authorization', this.getToken()),
    });
  }

  public delete(url: string, body?: any) {
    return this.http.delete(environment.api + url, {
      headers: new HttpHeaders().append('Authorization', this.getToken()),
    });
  }

  getToken() {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      const token = localStorage.getItem('crmtoken') || '';
      return token ? `Bearer ${token}` : '';
    }
    return '';
  }

  getLogin(data: any) {
    return this.post('login', data);
  }

  recoveryMail(data: any) {
    return this.post('recovery-email', data);
  }

  getProspectById(data: any) {
    return this.post('get-prospect', data);
  }

  createProspect(data: any) {
    return this.post('create-prospect', data);
  }

  updateProspect(data: any) {
    return this.post('update-prospect', data);
  }
  changeProspectOwner(data: any) {
    return this.post('change-prospect-owner', data);
  }

  getUsers() {
    return this.get('users');
  }
  updateUser(data: any): Observable<any> {
    return this.post('update-user', data);
  }

  updateUsersStatus(data: {
    userIds: string[];
    status: number;
  }): Observable<any> {
    return this.post('users/update-status', data);
  }

  deleteUser(data: { usuario_id: string }): Observable<any> {
    return this.post('delete-user', data);
  }

  createUser(data: any) {
    return this.post('create-user', data);
  }

  getProspects() {
    return this.get('prospects');
  }

  getProspectsUser(usuario_id: string) {
    return this.post('get-prospect-user', { usuario_id });
  }

  getAccountById(data: { id: string }) {
    console.log('Enviando a:', `${environment.api}cuenta/get-cuenta`);
    return this.post('cuenta/get-cuenta', data);
  }

  public getAccounts(params?: any) {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', this.getToken());
    return this.http.get(environment.api + 'accounts', {
      headers: headers,
      params: params,
    });
  }

  createAccount(data: any) {
    return this.post('create-cuenta', data);
  }

  updateAccount(data: any) {
    return this.post('update-cuenta', data);
  }

  deleteAccount(data: any) {
    return this.post('delete-cuenta', data);
  }

  changeAccountOwner(data:any){
    return this.post('account-changeOwner',data)
  }


  deleteProspect(data: any) {
    return this.post('delete-prospect', data);
  }

  getContactById(data: { id: string }) {
    return this.post('get-contacto', data);
  }

  createContact(data: any) {
    return this.post('create-contacto', data);
  }

  updateContact(data: any) {
    return this.post('update-contacto', data);
  }

  deleteContact(data: { contacto_id: string }) {
    return this.post('delete-contacto', data);
  }

  changeContactAccount(data: { contacto_id: string; nueva_cuenta: number }) {
    return this.post('contacto/change-account', data);
  }

  getContacts() {
    return this.get('contacts');
  }

  getOpportunities() {
    return this.get('oportunities');
  }

  deleteOportunity(data: any) {
    return this.post('delete-oportunidad', data);
  }

  updateOpportunity(data: any) {
    return this.post('update-oportunidad', data);
  }

  createOpportunity(data: any) {
    return this.post('create-oportunidad', data);
  }

  getOportunidad(id: string) {
    return this.get(`get-oportunidad/${id}`);
  }

  createOportunidad(data: any) {
    return this.post('create-oportunidad', data);
  }

  updateOportunidad(data: any) {
    return this.post('update-oportunidad', data);
  }

  deleteOportunidad(data: { id: string }) {
    return this.post('delete-oportunidad', data);
  }

  changeContactOwner(payload: any): Observable<any> {
    return this.post('contacto/cambiar-propietario', payload);
  }

  getContactFunctions(data: any) {
    return this.post('get-contacto-functions', data);
  }

  markOpportunity(data: any) {
    return this.post('mark-oportunidad', data);
  }

  changeSgtePasoOpportunity(data: any) {
    return this.post('update-sgtepaso-oportunidad', data);
  }

  updateContactFunction(data: any) {
    return this.post('update-contacto-function', data);
  }

  updateAmountOpportunity(data: any) {
    return this.post('update-amount-opportunity', data);
  }

  getStatusByType(data: any) {
    return this.post('get-estados-tipo', data);
  }

  getProspectStats(data: any) {
    return this.post('stats/prospecto', data);
  }

  getProspectOriginStats(data: any) {
    return this.post('stats/prospecto/origen', data);
  }

  getAccountIndustryStats(data: any) {
    return this.post('stats/cuenta/industria', data);
  }

  getTotalContactAccount(data: any) {
    return this.post('stats/total/cuentas-contactos', data);
  }

  getAccountStats(data: any) {
    return this.post('stats/cuenta', data);
  }

  getBudgets() {
    return this.get('presupuesto');
  }

  getBudgetById(id: string) {
    return this.get(`get-presupuesto/${id}`);
  }

  createBudget(data: any) {
    return this.post('create-presupuesto', data);
  }

  updateBudget(data: any) {
    return this.post('update-presupuesto', data);
  }

  deleteBudget(data: any) {
    return this.post('delete-presupuesto', data);
  }

  changeBudgetOwner(data: any) {
    return this.post('change-budget-owner', data);
  }

  getBudgetVersions(data: any) {
    return this.get('versions', data);
  }

  getUserPermissions(data: any) {
    return this.post('user-permiso', data);
  }

  updatePermission(data: any) {
    return this.post('update-permiso', data);
  }

  getOutlookEvents() {
    return this.get('outlook/events');
  }

  sendOutlookMail(data: any) {
    return this.post('outlook/send', data);
  }

  getUserPermiso(data: any): Observable<any> {
    return this.post('user-permiso', data);
  }

  changePassword(data: any): Observable<any> {
    return this.post('change-password', data);
  }

  createGoal(data: any) {
    return this.post('create-meta', data);
  }

  updateGoal(data: any) {
    return this.post('update-meta', data);
  }

  deleteGoal(data: any) {
    return this.post('delete-meta', data);
  }

  getGoals() {
    return this.get('metas');
  }

  getMetas(): Observable<any> {
    return this.get('metas-tendencia');
  }

  markGoal(data: any) {
    return this.post('mark-meta-oportunidad', data);
  }

  getmetasDashboard() {
    return this.get('dashboard-metas');
  }

  getTasks() {
    return this.get('tareas');
  }

  updateTaskStatus(data: any) {
    return this.post('update-status', data);
  }

  updateTaskPriority(data: any) {
    return this.post('update-priority', data);
  }

  getTaskbyId(id: string) {
    return this.get(`get_tarea/${id}`);
  }

  getMonthlyComplianceData(month: number, year: number): Observable<any> {
    return this.post('monthly-compliance', { month, year });
  }

  getWeeklyProgress() {
  return this.get(`weekly-progress`);
}

  createTarea(tareaData: any) {
    return this.post('create_tarea', tareaData);
  }

  updateTarea(tareaData: any): Observable<any> {
    return this.post('update_tarea', tareaData);
  }

  deleteTareasMultiples(data: { tarea_ids: string[] }): Observable<any> {
    console.log('Eliminando múltiples tareas:', data);
    return this.post('delete_tarea', data);
  }

  deleteTarea(tareaId: string): Observable<any> {
    console.log('Eliminando tarea individual:', tareaId);
    return this.post('delete_tarea', { tarea_id: tareaId });
  }
  changeTaskOwner(data: any): Observable<any> {
    console.log('Cambiando propietario - Datos enviados:', data);
    return this.post('change-task-owner', data);
  }

  getcontracts(){
    return this.get('contratos')
  }

  createContract(data:any){
    return this.post('create-contrato',data)
  }

  updateContract(data:any){
    return this.post('update-contrato',data)
  }

  deletecontract(data:any){
    return this.post('delete-contrato',data)
  }

  updateContractStatus(data:any){
    return this.post('update-status-contrato',data)
  }

  updateContractReminder(data:any){
    return this.post('update-reminder-contrato',data)
  }

  getContractbyId(id:string){
    return this.get(`get-contrato/${id}`)
  }

  getNextContractNumber() {
  return this.get('contracts/next-number');
  }

  uploadFile(formData: FormData) {
    return this.post('upload', formData);
  }

  deleteFile(payload: { fileUrl: string }) {
  return this.post('delete', payload);
  }

  getEntityFiles(data:any){
    return this.post('get/files',data);
  }

  getEntityTasks(data:any){
    return this.post('get-tarea-entidad', data);
  }

  getIndustrias(){
    return this.get('industrias');
  }

  createSegmento(data:any){
    return this.post('create/segmento/auto',data);
  }

  getSegmentos(){
    return this.get('segmentos');
  }

  createCampaign(data:any){
    return this.post('create/campana',data);
  }

  getCampanas(){
    return this.get('campanas');
  }

  getForecastReport(data: any){
    return this.post("forecast-report", data);
  }

  getOpportunityByEjecutivo(data:any){
    return this.post('get/oportunidad/ejecutivo', data);
  }

  sendCampaign(data:any){
    return this.post('send/campana', data);
  }

  deleteCampaign(data:any){
    return this.post('delete/campana', data);
  }
  getTaskByUser(data:any){
    return this.get('tareas-usuario',data)
  }

  getOportunidadesByUser() {
  return this.get('oportunidades-usuario')
  }; 

  getContratosByUser() {
  return this.get('contratos-usuario');
}

  getCuentasByUser() {
    return this.get('cuenta-usuario'); }

  getContactosByUser() {
    return this.get('contacto-usuario'); 
  }

  getTendenciaAnual(){
    return this.get('tendencia-anual');
  }

  getTopEjecutivos(){
    return this.get('top-ejecutivos');
  }

  getTopCuentas(){
    return this.get('top-cuentas');
  }


  getAvanceMensual(){
    return this.get('avance-mensual')
  }

  getResumenGeneral() {
    return this.get('resumen-general');
  }

  updateProspectStatus(data:any){
    return this.post('update-prospect-estado', data);
  }

  getProductsFromManager(){
    return this.get('manager/products/prices');
  }
  getEjecutivoTendencia() {
  return this.get('ejecutivo-tendencia');
}

  getEjecutivoCuentas() {
    return this.get('ejecutivo-cuentas');
  }

  getEjecutivoVentas() {
    return this.get('ejecutivo-ventas');
  }

  getEjecutivoAvance() {
    return this.get('ejecutivo-avance');
  }

  getEjecutivoResumen() { 
    return this.get('ejecutivo-resumen');
  }

  addProductsBudget(data:any){
    return this.post('add-products-budget', data);
  }

  deleteProductBudget(data:any){
    return this.post('delete-product-budget', data);
  }

  getBudgetItems(id: string){
    return this.get(`get-items/${id}`);
  }

  updateOpportunityStatus(data:any){
    return this.post('update-oportunidad-estado', data);
  }

  updateBudgetStatus(data:any){
    return this.post('update-presupuesto-estado', data);
  }
  getContactByAccount(id:any){
    return this.get(`cuentas/${id}/contactos`);
  }

  getOportunitiesByAccount(id:any){
    return this.get(`cuentas/${id}/oportunidades`);
  }

  getOportunitiesByContact(id:any){
    return this.get(`contacto/${id}/oportunidades`);
  }

  getBudgetsByContact(id:any){
    return this.get(`cuentas/${id}/presupuestos`);
  }

  getContractsByContact(id:any){
    return this.get(`contacto/${id}/contratos`);
  }
    

  getMyNotifications(){
    return this.get('my-notifications');
  }

  markNotificationAsRead(notificationId: string) {
    return this.post('marcar-leida', { notificacion_id: notificationId });
  }
  

  getCampaignById(data:any){
    return this.post('get/campana', data);
  }

  createManualSegment(data:any){
    return this.post('create/segmento/manual',data);
  }

  getOutlookInfo(){
    return this.get('outlook/email');
  }

  unlinkOutlookAccount(data:any){
    return this.post('outlook/unlink', data);
  }

  verifyRecoveryCode(data:any){
    return this.post('verify-recovery-code', data);
  }

  resetPassword(data:any){
    return this.post('reset-password-with-code', data);
  }
  
  getUserProfile(){
    return this.get('me')
  }

  getRol(){
    return this.get('roles')
  }

  updateUserStatusBatch(data:any){
    return this.post('update-user-status-batch',data)
  }

  getKpisOportunity(){
    return this.get('kpi-oportunidades')
  }

  createRecordatorio(data:any){
    return this.post('create-recordatorio',data)
  }

  getdefaultAccountOwner(){
    return this.get('default-account-owner')
  }
  
  getcontactsbycuenta(id:string){
    return this.get(`contacto/cuenta/${id}`);
  }

  adminResetPassword(data:{usuario_id:string; nuevaContrasena:string}){
    return this.post('admin-reset-password',data)
  }

}
